import React from 'react';
import { Container, Box, Typography, Grid, Card, CardContent } from '@mui/material';
import config from '../../config/env';

const AdminTestsPage: React.FC = () => {
  if (!config.IS_DEVELOPMENT) {
    // В production не рендерим и не импортируем тяжелые тестовые виджеты.
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            🛡️ Страница административных тестов недоступна в продакшене
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Интеграционные и нагрузочные тесты доступны только в development-сборке.
          </Typography>
        </Box>
      </Container>
    );
  }

  // ✅ Ниже код, который попадет только в development-бандл.
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const PerformanceTest = require('../../components/test/PerformanceTest').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const SecurityTest = require('../../components/test/SecurityTest').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const WebSocketTest = require('../../components/test/WebSocketTest').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const TranslationDebugger = require('../../components/test/TranslationDebugger').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const BackendIntegrationTest = require('../../components/test/BackendIntegrationTest').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const UsersApiTest = require('../../components/test/UsersApiTest').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const AuthApiTest = require('../../components/test/AuthApiTest').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const FinanceApiTest = require('../../components/test/FinanceApiTest').default as React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const DocumentsApiTest = require('../../components/test/DocumentsApiTest').default as React.ComponentType;

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          🧪 Административные интеграционные тесты
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Набор виджетов и проверок для ручного и полуавтоматического тестирования ключевых подсистем.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Производительность (26.1)</Typography>
              <PerformanceTest />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Безопасность (26.2)</Typography>
              <SecurityTest />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>WebSocket (26.4)</Typography>
              <WebSocketTest />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Переводы (26.6)</Typography>
              <TranslationDebugger />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>API тесты (26.5, 26.7)</Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(1, minmax(0, 1fr))', gap: 2 }}>
                <UsersApiTest />
                <AuthApiTest />
                <FinanceApiTest />
                <DocumentsApiTest />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Интеграционные проверки (26.3, 26.8)</Typography>
              <BackendIntegrationTest />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AdminTestsPage;
